module.exports = __webpack_public_path__ + "img/acrylicColor.05eac2be.jpg";